module.exports = __webpack_public_path__ + "img/refuse.jpg";